export default angular
  .module('st.Integrations.Slack', [])
  .service('slackService', ($q, $http, dataService, SLACK) => ({
    authenticate: () =>
      dataService.apiRequest(null, null, true, null, $http.get, SLACK.API.AUTHENTICATE, {}),
    authenticated: (params) =>
      dataService.apiRequest(null, null, true, null, $http.get, SLACK.API.AUTHENTICATED, {
        params
      }),
    deauthenticate: () =>
      dataService.apiRequest(null, null, true, null, $http.get, SLACK.API.DEAUTHENTICATE, {})
  }))
  .constant('SLACK', {
    API: {
      AUTHENTICATE: '/api/v1/integration/slack/authenticate',
      AUTHENTICATED: '/api/v1/integration/slack/authenticated',
      DEAUTHENTICATE: '/api/v1/integration/slack/deauthenticate'
    }
  });
